import React from 'react';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';
import type { ParticipationType } from 'app/types';

export const useParticipationFormValidation = (isEdit: boolean, availableTypes: ParticipationType[]) => {
  const intl = useIntl();

  const formikValidationSchema = React.useMemo(() => {
    if (isEdit) {
      return Yup.object().shape({
        endDate: Yup.string()
          .required()
          .test(
            'isAfterStartDate',
            intl.formatMessage({ id: 'employees.error.participationEndDate' }),
            function (value) {
              const { startDate } = this.parent;
              if (!value || !startDate) return true;
              return new Date(value).getTime() >= new Date(startDate).getTime();
            },
          ),
        reasonEnd: Yup.string().required(),
      });
    }
    return Yup.object().shape({
      startDate: Yup.string().required().nullable(),
      reasonStart: Yup.string().required(),
      type: Yup.string().required(),
    });
  }, [isEdit, intl]);

  return { formikValidationSchema };
};
